// extracted by mini-css-extract-plugin
export var plainBtn = "components-home-__HomeBanner-module___plainBtn";
export var wrapper = "components-home-__HomeBanner-module___wrapper";